export default {
    formId: 'exportControlTiemposFormModel', //'exportControlTiemposFormModel',
    formField: {
      from: {
        name: 'from',
        label: 'Desde*',
        requiredErrorMsg: 'La fecha inicio es requerida.'
      },
      to: {
        name: 'to',
        label: 'Hasta*',
        requiredErrorMsg: 'La fecha final es requerida.'
      },
    }
};
  